import {
  BookmarkedAwardsWithTitle,
  BookmarkedPagesWithTitle,
  BookmarkedResultsWithTitle,
  BookmarksWithTitle,
  BookmarToMyAccountWithTitle,
  EnguiriesWithTitle,
  EnquiryDetailsWithTitle,
  ProfileWithTitle,
  ResetPinWithTitle,
  ResourcesWithTitle,
  ViewExistingEnquiryWithTitle,
  FindMyAwardWithTitle,
  CreateFeedback,
  GetHelpLandingWithTitle,
  UnpaidWagesLandingWithTitle,
  InteractiveTemplateMain,
  WorkplaceBasicsWithTitle,
  ResetPasswordWithTitle,
  DisableUserWithTitle,
  EnquiryCloseWithTitle,
  EnquiryCancelWithTitle,
  ChangeUserEmailWithTitle,
  EnquiryAbandonWithTitle,
  ResetPasswordLandingWithTitle,
  ChangeABNWithTitle,
  DeleteBookmarksWithTitle,
  SubmitEnquiryWithTitle,
  EnquiryRequestForInformationLandingWithTitle,
} from './RouteConstants'
import PageNotFound from './PageNotFound'
import NetworkError from './NetworkError'
import Logout from './Logout'
import HomePage from './home/HomePage'
export interface IRoute {
  path?: string
  name: string
  component?: any
  parent?: IRoute[]
  allowAnonymous?: boolean
  showWebChat?: boolean
  showMenu?: boolean
  showFooterTools?: boolean
  title?: string
  showMegaMenu?: boolean
  hideBreadcrumb?: boolean
}

export enum PATHS {
  FWO = 'https://www.fairwork.gov.au/',
  Home = '/my-account',
  Register = '/my-account/register',
  ResetPIN = '/my-account/profile/resetPin',
  ChangeABN = '/my-account/profile/changeABN',
  DisableUser = '/my-account/disable-user',
  ResetPassword = '/my-account/profile/resetPassword',
  ResetPasswordLanding = '/my-account/profile/changePassword',
  ChangeUserEmail = '/my-account/profile/changeUserEmail',
  MyAccount = 'https://www.services.fairwork.gov.au/my-account',
  Profile = '/my-account/profile',
  UnpaidWageSearch = '/search-for-unpaid-wages',
  ChangeMFAPhoneLanding = '/my-account/profile/changeMFAPhoneLanding',
  ChangeMFAPhoneVerifyEmail = '/my-account/profile/changeMFAPhoneVerifyEmail',
  ChangeMFAPhoneVerifySMS = '/my-account/profile/changeMFAPhoneVerifySMS',
}

const defaultRoutes: IRoute[] = [{ name: 'Home', path: PATHS.Home }]
const Routes: IRoute[] = [
  {
    path: '/find-my-award',
    name: 'Find my award',
    component: FindMyAwardWithTitle,
    allowAnonymous: true,
    showWebChat: false,
    showMenu: false,
    showFooterTools: true,
    showMegaMenu: true,
    title: 'Find my award',
  },
  {
    path: '/my-account/enquiries',
    name: 'Enquiries',
    component: EnguiriesWithTitle,
    parent: [{ name: 'My account', path: PATHS.Home }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/enquiry/submit-a-new-enquiry',
    name: 'Submit your enquiry',
    component: SubmitEnquiryWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Enquiries', path: '/my-account/enquiries' },
    ],

    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/enquiry/:id/edit/:step?',
    name: 'View existing enquiry',
    component: ViewExistingEnquiryWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Enquiries', path: '/my-account/enquiries' },
    ],
    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/enquiry/cancel',
    name: 'Enquiry details',
    component: EnquiryCancelWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Enquiries', path: '/my-account/enquiries' },
    ],
    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/enquiry/close',
    name: 'Enquiry details',
    component: EnquiryCloseWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Enquiries', path: '/my-account/enquiries' },
    ],
    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/enquiry/:id/requestInformation',
    name: 'Enquiry details',
    component: EnquiryRequestForInformationLandingWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Enquiries', path: '/my-account/enquiries' },
    ],
    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/enquiry/:id/details',
    name: 'Enquiry details',
    component: EnquiryDetailsWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Enquiries', path: '/my-account/enquiries' },
    ],
    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/enquiry/abandon',
    name: 'Enquiry details',
    component: EnquiryAbandonWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Enquiries', path: '/my-account/enquiries' },
    ],
    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },

  {
    name: 'Feedback',
    path: '/feedback/submit-a-feedback',
    component: CreateFeedback,
    allowAnonymous: true,
    showMenu: false,
    showFooterTools: true,
    title: 'Feedback form - Fair Work Ombudsman',
    showMegaMenu: true,
    hideBreadcrumb: false,
  },

  {
    name: 'InteractiveTemplate',
    path: '/tools-and-resources/templates/:id',
    component: InteractiveTemplateMain,
    allowAnonymous: true,
    showMenu: false,
    showFooterTools: true,
    title: 'Generate documents from templates - Fair Work Ombudsman',
    showMegaMenu: true,
    hideBreadcrumb: false,
  },

  {
    path: '/my-account/resources',
    name: 'Resources',
    component: ResourcesWithTitle,
    parent: [{ name: 'My account', path: PATHS.Home }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },

  {
    path: '/my-account/BookmarkToMyAccount',
    name: 'Bookmark to My account',
    component: BookmarToMyAccountWithTitle,
    parent: defaultRoutes,
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },

  {
    path: '/my-account/bookmarked-awards',
    name: 'Awards',
    component: BookmarkedAwardsWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Bookmarks', path: '/my-account/bookmarks' },
    ],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/bookmarked-pages',
    name: 'Pages',
    component: BookmarkedPagesWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Bookmarks', path: '/my-account/bookmarks' },
    ],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/bookmarked-results',
    name: 'Resutls',
    component: BookmarkedResultsWithTitle,
    parent: [
      { name: 'My account', path: PATHS.Home },
      { name: 'Bookmarks', path: '/my-account/bookmarks' },
    ],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },

  {
    path: '/my-account/bookmarks',
    name: 'Bookmarks',
    component: BookmarksWithTitle,
    parent: [{ name: 'My account', path: PATHS.Home }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },

  {
    path: '/my-account/bookmarks-delete',
    name: 'BookmarksDelete',
    component: DeleteBookmarksWithTitle,
    parent: [{ name: 'Bookmarks', path: '/my-account/bookmarks' }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/my-account/profile/resetPin',
    name: 'Reset Pin',
    component: ResetPinWithTitle,
    parent: [{ name: 'My account', path: PATHS.Home }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showMegaMenu: false,
    hideBreadcrumb: true,
  },
  {
    path: '/my-account/profile/changeABN',
    name: 'Change ABN',
    component: ChangeABNWithTitle,
    parent: [{ name: 'My account', path: PATHS.Home }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showMegaMenu: false,
    hideBreadcrumb: true,
  },
  {
    path: '/my-account/disable-user',
    name: 'Disable User',
    component: DisableUserWithTitle,
    parent: [{ name: 'My account', path: PATHS.Home }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showMegaMenu: false,
    hideBreadcrumb: true,
  },
  {
    path: '/my-account/profile/changeUserEmail',
    name: 'Change user email',
    component: ChangeUserEmailWithTitle,
    parent: [{ name: 'My account', path: PATHS.Home }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showMegaMenu: false,
    hideBreadcrumb: true,
  },
  // {
  //   path: '/my-account/profile/changeMFAPhoneLanding',
  //   name: 'Change MFA phone',
  //   component: ChangeMFAPhoneLandingWithTitle,
  //   parent: [{ name: 'My account', path: PATHS.Home }],
  //   allowAnonymous: false,
  //   showWebChat: true,
  //   showMenu: true,
  //   showMegaMenu: false,
  //   hideBreadcrumb: true,
  // },
  
  // {
  //   path: '/my-account/profile/changeMFAPhoneVerifyEmail',
  //   name: 'Change MFA phone - verify email',
  //   component: ChangeMFAPhoneVerifyEmailWithTitle,
  //   parent: [{ name: 'My account', path: PATHS.Home }],
  //   allowAnonymous: false,
  //   showWebChat: true,
  //   showMenu: true,
  //   showMegaMenu: false,
  //   hideBreadcrumb: true,
  // },
  // {
  //   path: '/my-account/profile/changeMFAPhoneVerifySMS',
  //   name: 'Change MFA phone - verify SMS',
  //   component: ChangeMFAPhoneVerifySMWithTitle,
  //   parent: [{ name: 'My account', path: PATHS.Home }],
  //   allowAnonymous: false,
  //   showWebChat: true,
  //   showMenu: true,
  //   showMegaMenu: false,
  //   hideBreadcrumb: true,
  // },
  {
    path: PATHS.ResetPasswordLanding,
    name: 'Change password',
    component: ResetPasswordLandingWithTitle,
    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    title: 'Change password',
    hideBreadcrumb: true,
  },
  {
    path: PATHS.ResetPassword,
    name: 'Reset Password',
    component: ResetPasswordWithTitle,
    allowAnonymous: false,
    showWebChat: false,
    showMenu: false,
    showFooterTools: false,
    showMegaMenu: false,
    title: 'Registration',
    hideBreadcrumb: true,
  },

  {
    path: '/my-account/profile',
    name: 'Profile',
    component: ProfileWithTitle,
    parent: [{ name: 'My account', path: PATHS.Home }],
    allowAnonymous: false,
    showWebChat: true,
    showMenu: true,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: '/get-help',
    name: 'Get help',
    component: GetHelpLandingWithTitle,
    allowAnonymous: true,
    showMenu: false,
    showFooterTools: true,
    showMegaMenu: true,
    title: 'Get help',
  },
  {
    path: '/search-for-unpaid-wages',
    name: 'Search for unpaid wages',
    component: UnpaidWagesLandingWithTitle,
    allowAnonymous: true,
    showMenu: false,
    showFooterTools: true,
    showMegaMenu: true,
    title: 'Search for unpaid wages',
  },
  {
    path: '/workplace-basics',
    name: 'Workplace basics quiz',
    component: WorkplaceBasicsWithTitle,
    allowAnonymous: true,
    showMenu: false,
    showFooterTools: true,
    showMegaMenu: true,
    title: 'Workplace basics quiz',
  },
  {
    path: '/my-account/logout',
    name: 'Logout',
    component: Logout,
    parent: null,
    allowAnonymous: true,
    showMenu: false,
    showFooterTools: false,
    showMegaMenu: false,
  },
  {
    path: '/network-error',
    name: 'Network error',
    component: NetworkError,
    parent: null,
    allowAnonymous: true,
    showWebChat: false,
    showMenu: true,
    showMegaMenu: false,
    hideBreadcrumb: false,
  },
  {
    path: PATHS.Home,
    name: 'Home',
    component: HomePage,
    allowAnonymous: false,
    showWebChat: false,
    showMenu: true,
    showFooterTools: false,
    showMegaMenu: false,
    title: 'Home',
    hideBreadcrumb: false,
  },

  {
    name: 'Page not found',
    component: PageNotFound,
    parent: null,
    allowAnonymous: true,
    showWebChat: false,
    showMenu: false,
    showMegaMenu: false,
  },
]

export default Routes
